import { notification } from "antd";

export const useNotification = () => {
    const showNotification = (type, message, description) => {
        notification[type]({
            message,
            description,
            iconLoading: false
        });
    };

    const success = (message, description = "") => {
        showNotification("success", message, description);
    };

    const error = (message, description = "") => {
        showNotification("error", message, description);
    };

    const warning = (message, description = "") => {
        showNotification("warning", message, description);
    };

    const info = (message, description = "") => {
        showNotification("info", message, description);
    };

    return { success, error, warning, info, showNotification };
};
